import { ColorUnion, Tag as TagComponent } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  costCenterName: string
  percentage: string
  index: number
}

const _COLORS: ColorUnion[] = [
  'tangerine',
  'purple',
  'lime',
  'neutral',
  'viridian',
  'radical',
  'grey',
  'malibu',
  'champagne',
  'grey3',
  'fuchsia',
  'negative',
  'grey4',
  'brand',
  'accent',
  'correct',
  'wrong',
  'grey5',
  'terciary',
  'brandLight',
  'brandLightNegative',
  'transparent',
  'ai',
]

export const Tag = ({ costCenterName, percentage, index }: Props) => {
  return (
    <TagComponent type={_COLORS[index % _COLORS.length]}>
      {i18n.t('cost_centers.tag.text_with_percentage', { costCenterName, percentage })}
    </TagComponent>
  )
}
